import React from 'react'
import './products.css'
export default function product() {
  return (
    <div className='products'>
      {/*product 1*/}
      <div className='product'>
      <div className='leftside'>
      <h1>Solar Roof-top Mini To Mega Power Plants</h1>
      <p>Our products Are used in small scale to medium level projects such as Hospital,Industries,Hotels,eductaion.</p>
      <p>Solar rooftop power plants, whether mini or mega in scale, are an innovative solution to harnessing renewable energy right where it’s needed. These installations, which vary in capacity from a few kilowatts for residential rooftops to several megawatts for commercial and industrial applications, offer a sustainable and efficient way to generate electricity.</p>
      </div>
      <div className='rightside'>
        <img className='image' src='./img2.jpeg' alt=''/>
        <br></br>
        <br></br>
      </div>
      </div>

      {/*product 2*/}
      <div className='product'>
      <div className='leftside'>
      <h1>Solar Tree</h1>
      <p>A solar tree is an innovative structure designed to harness solar energy efficiently in a small footprint, much like the way a real tree gathers sunlight through its branches and leaves. Typically made with a central trunk and “branches” extending outward, each branch holds solar panels that capture sunlight and convert it into electricity. Solar trees combine aesthetics with technology, making them an attractive option for urban and rural areas where traditional solar arrays may not fit or where enhanced visibility for green technology is desired.</p>
      </div>
      <div className='rightside'>
        <img className='image' src='./img12.jpg' alt=''/>
        <br></br>
        <br></br>
      </div>
      </div>

      {/*product 3*/}
      <div className='product'>
      <div className='leftside'>
      <h1>Solar Agriculture Water pumping Scheme</h1>
      <p>Solar agriculture water pumping technology uses solar energy to power water pumps, providing an efficient and sustainable way to irrigate agricultural fields. By converting sunlight into electricity through solar panels, these systems drive pumps that lift or move water from sources such as rivers, lakes, ponds, or wells directly to fields or storage tanks. This technology is especially useful in remote or rural areas where access to conventional power grids may be limited.</p>
      </div>
      <div className='rightside'>
        <img className='image' src='./img13.jpeg' alt=''/>
        <br></br>
        <br></br>
      </div>
      </div>

      {/*product 4*/}
      <div className='product'>
      <div className='leftside'>
      <h1>Solar Fencing</h1>
      <p>Solar fencing is an innovative and eco-friendly security solution that uses solar power to create a protective barrier around properties, agricultural lands, and other areas requiring secure boundaries. This type of fencing employs electric pulses powered by solar energy, providing a reliable and non-harmful way to deter intruders, wild animals, and unauthorized entry without relying on conventional electricity.</p>
      </div>
      <div className='rightside'>
        <img className='image' src='./img14.jpg' alt=''/>
        <br></br>
        <br></br>
      </div>
      </div>

    </div>
  )
}
